/**
 * Validates if a concept code is in the correct format: #####-###
 * @param conceptCode - The concept code to validate
 * @returns True if the concept code is valid, false otherwise
 */
export const checkIfStringIsValidConceptCode = (conceptCode: string): boolean => {
  if (!conceptCode || conceptCode.trim().length === 0) {
    return false;
  }

  // Check if it matches the format #####-### (5 digits, hyphen, 3 digits)
  const conceptCodePattern = /^\d{5}-\d{3}$/;
  return conceptCodePattern.test(conceptCode.trim());
};

/**
 * Formats a concept code string to follow the #####-### format
 * @param value - The input string to format
 * @returns The formatted concept code
 */
export const formatConceptCode = (value: string): string => {
  // Remove any non-digit characters
  const digits = value.replace(/[^\d]/g, '').slice(0, 8);

  // Format with hyphen: #####-###
  if (digits.length <= 5) {
    return digits;
  } else {
    return `${digits.slice(0, 5)}-${digits.slice(5)}`;
  }
};

/**
 * Gets the validation error message for a concept code
 * @param conceptCode - The concept code to validate
 * @returns Error message if invalid, empty string if valid
 */
export const getConceptCodeError = (conceptCode: string): string => {
  if (!conceptCode || conceptCode.trim().length === 0) {
    return 'Concept Code is required';
  }

  if (!checkIfStringIsValidConceptCode(conceptCode)) {
    return 'Concept Code must be in format: #####-###';
  }

  return '';
};
